import {
  NameColumnDef,
  EmailColumnDef,
  AddressColumnDef,
  CityColumnDef,
  CountryColumnDef,
  StateColumnDef,
  ZipcodeColumnDef,
  PhoneColumnDef,
  FaxColumnDef,
  ContactColumnDef,
} from "components/AGTable/NewColumns/ColumnDefinition";

const defaultColDef = {
  sortable: true,
  resizable: true,
  cellClass: "no-border",
  cellStyle: { display: "flex", "justify-content": "center" },
  filter: true,
};

export const warehouseGrid = {
  columnDefs: [
    NameColumnDef,
    AddressColumnDef,
    CityColumnDef,
    StateColumnDef,
    CountryColumnDef,
    ZipcodeColumnDef("zip"),
    PhoneColumnDef,
    EmailColumnDef,
    FaxColumnDef,
    ContactColumnDef,
  ],
  defaultColDef,
};
